import React from 'react';
import './Rooms.css';

const Rooms = () => {
  const rooms = [
    {
      id: 1,
      name: 'Double Bed Room',
      description: 'Comfortable double bed room perfect for couples or solo travelers. Features modern amenities and clean, well-maintained facilities.',
      price: 'Contact for Rates',
      image: '/images/gallery/double-bed/main.jpg',
      features: ['Double Bed', 'Air Conditioning', 'TV', 'Free WiFi', 'Clean Toilet', 'Hot & Cold Water', 'Toiletries Provided', 'Power Inverter']
    },
    {
      id: 2,
      name: 'Four-Person Room',
      description: 'Spacious room ideal for families or small groups. Accommodates up to 4 people comfortably with all modern conveniences. Perfect for families visiting Ujjain.',
      price: 'Contact for Rates',
      image: '/images/gallery/four-person/main.jpg',
      features: ['4-Person Capacity', 'Air Conditioning', 'TV', 'Free WiFi', 'Clean Toilet', 'Hot & Cold Water', 'Toiletries Provided', 'Power Inverter']
    },
    {
      id: 3,
      name: 'Group Hall',
      description: 'Large hall perfect for group gatherings, meetings, or events. Can comfortably accommodate up to 12 people.',
      price: 'Contact for Rates',
      image: '/images/gallery/group-hall/main.jpg',
      features: ['12 Person Capacity', 'Spacious Hall', 'Air Conditioning', 'Free WiFi', 'Perfect for Events', 'Group Gatherings']
    }
  ];

  return (
    <section id="rooms" className="rooms section">
      <div className="container">
        <h2 className="section-title">Our Rooms</h2>
        <p className="section-subtitle">Choose Your Perfect Accommodation</p>
        
        <div className="rooms-grid">
          {rooms.map(room => (
            <div key={room.id} className="room-card">
              <div className="room-image">
                <img src={room.image} alt={room.name} onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }} />
                <div className="image-placeholder" style={{display: 'none'}}>
                  <span>Room Image</span>
                </div>
                <div className="room-price">{room.price}</div>
              </div>
              <div className="room-content">
                <h3>{room.name}</h3>
                <p>{room.description}</p>
                <ul className="room-features">
                  {room.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Rooms;

